const SimpleAccordion = require('./lum-simple-accordion.js');

(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-simple-accordion:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }
        
        const $module = $(`.fl-node-${data.node}`);
        const module = new SimpleAccordion($module, data);
    }
})(jQuery);